import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: require('./auth').default,
    common: require('./common').default,
  },

  actions: {
    resetStore ({ commit }) {
      commit('RESET')
    },
  }
})
